import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SalesOrderOrderOverviewImport = _resolveComponent("SalesOrderOrderOverviewImport")!
  const _component_UserOperatingEntity = _resolveComponent("UserOperatingEntity")!

  return (_openBlock(), _createBlock(_component_UserOperatingEntity, null, {
    mb: _withCtx(() => [
      _createVNode(_component_SalesOrderOrderOverviewImport, {
        type: 1,
        checkValue: 14
      })
    ]),
    te: _withCtx(() => [
      _createVNode(_component_SalesOrderOrderOverviewImport, {
        type: 1,
        checkValue: _ctx.getDoubleSaleValue
      }, null, 8, ["checkValue"])
    ]),
    _: 1
  }))
}